<script lang="ts">
  import TooltipHybridButton from "../search/TooltipHybridButton.svelte";

  export let id: string;
  export let label: string;
  export let tooltip: string = "";
</script>

<div class="row-item">
  <div class="row-content">
    <div class="label-container">
      {label}
      {#if tooltip}
        <!-- <i class="bi bi-question-circle-fill ms-2" id={`tooltip-${id}`} />-->
        <TooltipHybridButton
          searchUrlQueryParam={id}
          tooltip={tooltip}
        />
        <!--        <Tooltip target={`tooltip-${id}`} placement="right">-->
        <!--          {@html tooltip}-->
        <!--        </Tooltip>-->
      {/if}
    </div>
    <div class="value-text">
      <slot />
    </div>
  </div>
</div>

<style>
    .row-item {
        padding: 1rem 0;
        border-top: 1px solid #dee2e6;
    }

    .row-content {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 2rem;
    }

    .label-container {
        flex: 0 0 30%;
        font-weight: 500;
    }

    .value-text {
        flex: 0 0 65%;
        color: #666;
        line-height: 1.5;
    }
</style>
